// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon{-webkit-filter:grayscale(100%);filter:grayscale(100%)}", ""]);
// Exports
module.exports = exports;
